// extracted by mini-css-extract-plugin
export default {"headerContainer":"styles_headerContainer__QVNnZ","header":"styles_header__SijuG","networkHeader":"styles_networkHeader__QpfR9","buttons":"styles_buttons__3kAzp"};